import { render, staticRenderFns } from "./AdvocatAppItemCard.vue?vue&type=template&id=08243576&scoped=true&lang=pug&"
import script from "./AdvocatAppItemCard.vue?vue&type=script&lang=js&"
export * from "./AdvocatAppItemCard.vue?vue&type=script&lang=js&"
import style0 from "./AdvocatAppItemCard.vue?vue&type=style&index=0&id=08243576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08243576",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout,VSpacer})
